import React from 'react';
import { Btn } from './ui';
import { C } from '../data/constants';

const SLIDES = [
  {
    bg: '#FFF3D0', accent: C.amber, label: 'ANCIENT EGYPT', icon: '𓂀',
    title: 'One of humanity\'s greatest civilizations 🏛️',
    body: 'Ancient Egypt was a Black African civilization that endured for over 3,000 years — producing extraordinary achievements in architecture, medicine, mathematics, philosophy and governance.',
    tip: 'Imhotep, an Egyptian polymath around 2650 BCE, was the world\'s first named physician and architect. He was still being venerated as a god of medicine 2,000 years after his death.',
    tipBg: '#FFF9E8', tipBorder: '#FFD080',
  },
  {
    bg: '#E0F8F0', accent: C.teal, label: 'THE MOORS OF AL-ANDALUS', icon: '🕌',
    title: 'Black Africans who built a world of learning 📚',
    body: 'Black African Moors built one of the most sophisticated civilizations of the medieval world in Al-Andalus (Spain), lasting 781 years. Córdoba had 70 libraries, 300 public baths, and universities that drew scholars from across the known world.',
    tip: 'Averroes, Ziryab and Al-Zahrawi — African Moorish scholars who shaped philosophy, music, surgery and science — left a legacy still felt in how the world thinks and heals today.',
    tipBg: '#E0FBF5', tipBorder: C.teal,
  },
  {
    bg: '#FFE8E0', accent: C.coral, label: 'YOUR JOURNEY STARTS HERE', icon: '⚔️',
    title: 'Explore. Learn. Go deeper. 🌍',
    body: 'Every question is a doorway into one of Africa\'s great civilizations. Earn titles, challenge friends with duel codes, and let the depth of these stories pull you in.',
    tip: 'The more you discover, the more you\'ll want to explore. African history is vast, rich, and endlessly fascinating — and this is just the beginning.',
    tipBg: '#FFF0EC', tipBorder: C.coral,
    isLast: true,
  },
];

export default function Onboarding({ slideIndex, onNext, onBack, onFinish }) {
  const s = SLIDES[slideIndex];
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Hero */}
      <div style={{ height: 185, background: `linear-gradient(180deg,${s.bg},#FFFAF2)`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 68 }}>{s.icon}</div>
          <div style={{ fontSize: 11, fontWeight: 700, color: s.accent, letterSpacing: '.1em', marginTop: 6 }}>{s.label}</div>
        </div>
      </div>
      {/* Body */}
      <div className="scroll-area" style={{ padding: '1.25rem' }}>
        {/* Progress dots */}
        <div style={{ display: 'flex', gap: 5, marginBottom: 12 }}>
          {SLIDES.map((_, i) => (
            <div key={i} style={{ flex: 1, height: 6, borderRadius: 3, background: i <= slideIndex ? C.amber : C.border }} />
          ))}
        </div>
        <div style={{ fontSize: 20, fontWeight: 900, color: C.text, lineHeight: 1.25, marginBottom: 10 }}>{s.title}</div>
        <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.7, marginBottom: 10 }}>{s.body}</div>
        <div style={{ background: s.tipBg, border: `2px solid ${s.tipBorder}`, borderRadius: 10, padding: '10px 12px', marginBottom: 16, fontSize: 12, color: C.muted }}>
          💡 {s.tip}
        </div>
        <Btn variant={s.isLast ? 'green' : 'orange'} onClick={s.isLast ? onFinish : onNext}>
          {s.isLast ? "Let's explore! 🌍" : 'Next →'}
        </Btn>
        {slideIndex > 0 && <Btn variant="white" onClick={onBack}>← Back</Btn>}
      </div>
    </div>
  );
}
